<template>
    <main>
        <div class="container-fluid">
            <div class="mainButton">
                <div class="row">
                    <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-end">
                        <DownloadAction v-if="downloadAction" ref="loaddownload"></DownloadAction>
                    </div>
                </div>
            </div>
            <div class="page-toolbar">
                <div class="page-title">
                    <span class="title">Detail Invitee</span> 
                    <span class="star"> <i class="fa-solid fa-star"></i></span>
                </div>
            </div>
        </div>
        <GenericDetail v-if="generic" ref="loadGeneric"></GenericDetail>
        <CustomDetail v-else></CustomDetail>

        <template v-if="btnShowHide">
            <GenericMoreButton v-if="genericBtn" ref="loadgenericbtn"></GenericMoreButton>
            <CustomMoreButton v-else></CustomMoreButton>
        </template>
    </main>
</template>

<script>
    import { ref } from "vue";
    import breadcrumbs from "@/views/modules/Invitees/MenuList.vue";
    import lang from "@/views/modules/Invitees/language/en";
    import GenericDetail from "@/components/layout/shared/generic/DetailView.vue";
    import CustomDetail from "@/views/modules/Invitees/DetailView.vue";
    import GenericMoreButton from "@/components/layout/shared/generic/common/MoreButton.vue";
    import CustomMoreButton from "@/views/modules/Invitees/MoreButton.vue";
    import DownloadAction from "@/components/layout/shared/generic/download/Download.vue";

    export default {
        name: "new-invitee",
        components: {
            breadcrumbs,
            GenericDetail,
            CustomDetail,
            CustomMoreButton,
            GenericMoreButton,
            DownloadAction
        },
        data() {
            return {
                generic: true,
                genericBtn: true,
                btnShowHide:true,
                lang: [],
                metaList: [
                    {
                        name: 'col1',
                        items: [
                            {
                                name: 'assigned_user',
                                label: lang.LBL_PI_NAME,
                                routePath: 'invitees',
                                link: false,
                            },
                            {
                                name: 'mobile',
                                label: lang.LBL_PI_MOBILE,
                                link: false,
                            },
                            {
                                name: 'professional',
                                label: lang.LBL_PI_PROFESSIONAL,
                                link: false,
                            },
                        ]
                    },

                    {
                        name: 'col2',
                        items: [
                            {
                                name: 'description',
                                label: lang.LBL_DESCRIPTION,
                                link: false,
                            },
                            {
                                name: 'parent_type',
                                label: lang.LBL_PARENT_TYPE,
                                link: false,
                            },
                            {
                                name: 'parent_id',
                                label: lang.LBL_PARENT_ID,
                                link: false,
                            },
                        ]
                    },

                    {
                        name: 'col3',
                        items: [
                            {
                                name: 'created_by',
                                label: lang.LBL_CREATED_BY,
                                link: false,
                                routePath: ''
                            },
                            {
                                name: 'date_entered',
                                label: lang.LBL_CREATE_DATE,
                                link: false,
                                routePath: ''
                            },
                            {
                                name: 'date_modified',
                                label: lang.LBL_MODIFIED_DATE,
                                link: false,
                                routePath: ''
                            },
                        ]
                    }
                ],
                moreBtn: [
                    {
                        id: 'edit',
                        path: 'invitees',
                        label: lang.LBL_EDIT,
                        action: 'edit',
                    },
                    {
                        id: 'delete',
                        path: 'invitees',
                        label: lang.LBL_DELETE,
                        action: 'delete',
                    },

                ],
                routePath: {
                    path: 'invitees',
                    detail: false
                },
                downloadAction: false,
                dowlloadList: [
                    {
                        label: lang.LBL_DOWNLOAD_ONE,
                        action: "/invitees/generate-pdf",
                        module: "Invitee",
                    },
                    {
                        label: lang.LBL_DOWNLOAD_TWO,
                        action: "",
                        module: "",
                    }
                ],
                record: null,
            }
        },
        mounted() {
            this.childMethod();
            this.lang = lang;
            this.showdowmload();
        },
        methods: {
            childMethod() {
                if (this.generic == true) {
                    this.$refs.loadGeneric.loadGenericView(this.metaList, this.routePath);
                }
                if (this.genericBtn == true) {
                    this.$refs.loadgenericbtn.loadGenericBtn(this.moreBtn);
                }
            },
            showdowmload() {
                const self = this;
                if (self.downloadAction == true) {
                    this.$refs.loaddownload.loadDownloadView(self.dowlloadList);
                }
            }
        }
    }

</script>